import Container from '@ui/shared/components/Container'

import { NonVisiblePage, Page } from './domain/page'

export default function Hero({ title, subtitle }: Page | NonVisiblePage) {
  return (
    <Container className='flex flex-col gap-1 items-center text-center max-w-5xl!'>
      <h1 className='mt-1 font-semibold tracking-tight text-4xl md:text-6xl'>{title}</h1>
      {subtitle && <h2 className='mt-5 text-base md:text-xl'>{subtitle}</h2>}
    </Container>
  )
}
